import AppLayout from '@pages/_layout/AppLayout';
import { findForwardRouteForConfigRoot } from '@pages/_loader/runRouteGuards';
import Modes from '@pages/Home/pages/Config/pages//Modes';
import TSCConfig from '@pages/Home/pages/Config/pages/TSCConfig';
import { PageNotFound } from '@pages/PageError';
import CalendarView from '@src/components/Home/Config/Calendar/CalendarView';
import TemplatesList from '@src/components/Home/Config/ConfigurableModes/TemplatesList';
import HMIDefault from '@src/components/Home/Config/Stacks/HMIDefault';
import StacksList from '@src/components/Home/Config/Stacks/StackList';
import { SiteMeta } from '@src/types/SiteMeta';
import { Navigate, RouteObject, useRouteLoaderData } from 'react-router';
import ConfigProvider from './ConfigWrapperContext';
import TopBar from './TopBar';

function RouteForward() {
  const siteMeta = useRouteLoaderData('root') as SiteMeta;
  const forwardPath = findForwardRouteForConfigRoot(siteMeta);
  return forwardPath ? <Navigate to={forwardPath} /> : <PageNotFound />;
}

function CheckConfigRootRoutePerms() {
  const siteMeta = useRouteLoaderData('root') as SiteMeta;
  const forwardPath = findForwardRouteForConfigRoot(siteMeta);
  return forwardPath ? (
    <ConfigProvider>
      <AppLayout isNested topBar={<TopBar />} />
    </ConfigProvider>
  ) : (
    <PageNotFound />
  );
}

export default [
  {
    path: 'config',
    element: <CheckConfigRootRoutePerms />,
    children: [
      {
        index: true,
        element: <RouteForward />,
      },
      { path: 'default-stack', element: <HMIDefault /> },
      { path: 'calendar', element: <CalendarView /> },
      { path: 'stacks', element: <StacksList /> },
      {
        path: 'modes',
        element: <TemplatesList />,
      },
      {
        path: 'basic-modes',
        element: <Modes />,
      },
      { path: 'tsc-config', element: <TSCConfig /> },
    ],
  },
] as RouteObject[];
